import React, { useEffect } from "react"

export const C = {
  bg: "#F6F8FD",
  card: "#FFFFFF",
  panel: "#E8EDFB",
  border: "#D5DFF7",
  borderDark: "#C0CEF1",
  ink: "#1A253C",
  indigo: "#4F46E5",
  indigoDark: "#3B32B3",
  coral: "#F43F5E",
  coralDark: "#D22E4D",
  amber: "#F59E0B",
  amberDark: "#D97706",
  green: "#10B981",
  greenDark: "#047857",
  muted: "#626E86",
  dark: "#121826",
  darkCard: "#1E293B",
  highlight: "#EEF2FF",
  tan: "#C9B088",
  white: "#FFFFFF",
}

export const F = {
  display: "'Outfit', sans-serif",
  body: "'Nunito', sans-serif",
}

const FONTS_HREF =
  "https://fonts.googleapis.com/css2?family=Outfit:wght@500;600;700;800;900&family=Nunito:wght@500;600;700;800;900&display=swap"

export function useScattergoriesFonts() {
  useEffect(() => {
    if (document.querySelector(`link[href="${FONTS_HREF}"]`)) return
    const link = document.createElement("link")
    link.rel = "stylesheet"
    link.href = FONTS_HREF
    document.head.appendChild(link)
  }, [])
}

export function Screen({ dark = false, children, style }) {
  return (
    <div
      style={{
        minHeight: "100dvh",
        background: dark ? C.dark : C.bg,
        color: dark ? C.bg : C.ink,
        fontFamily: F.body,
        display: "flex",
        flexDirection: "column",
        padding: "24px 20px 28px",
        boxSizing: "border-box",
        maxWidth: 520,
        margin: "0 auto",
        width: "100%",
        ...style,
      }}
    >
      {children}
    </div>
  )
}

const buttonStyles = {
  indigo: { background: C.indigo, color: C.white, shadow: C.indigoDark },
  coral: { background: C.coral, color: C.white, shadow: C.coralDark },
  panel: { background: C.panel, color: C.ink, shadow: "transparent" },
  ghost: { background: "transparent", color: C.indigo, shadow: "transparent" },
}

export function SgButton({ variant = "indigo", onClick, disabled, children, style }) {
  const v = buttonStyles[variant]
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={{
        height: 56,
        border: "none",
        borderRadius: 16,
        background: v.background,
        color: v.color,
        fontWeight: 800,
        fontSize: 17,
        fontFamily: F.display,
        boxShadow: v.shadow === "transparent" ? "none" : `0 4px 0 ${v.shadow}`,
        cursor: disabled ? "default" : "pointer",
        opacity: disabled ? 0.45 : 1,
        width: "100%",
        transition: "transform 0.1s ease, opacity 0.2s ease",
        ...style,
      }}
      onMouseDown={(e) => {
        if (!disabled && v.shadow !== "transparent") {
          e.currentTarget.style.transform = "translateY(2px)"
          e.currentTarget.style.boxShadow = `0 2px 0 ${v.shadow}`
        }
      }}
      onMouseUp={(e) => {
        if (!disabled && v.shadow !== "transparent") {
          e.currentTarget.style.transform = "none"
          e.currentTarget.style.boxShadow = `0 4px 0 ${v.shadow}`
        }
      }}
      onMouseLeave={(e) => {
        if (!disabled && v.shadow !== "transparent") {
          e.currentTarget.style.transform = "none"
          e.currentTarget.style.boxShadow = `0 4px 0 ${v.shadow}`
        }
      }}
    >
      {children}
    </button>
  )
}

export function Pill({ children, style }) {
  return (
    <span
      style={{
        background: C.panel,
        border: `1.5px solid ${C.borderDark}`,
        borderRadius: 999,
        padding: "5px 12px",
        fontWeight: 800,
        fontSize: 13,
        letterSpacing: 1,
        fontFamily: F.display,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        ...style,
      }}
    >
      {children}
    </span>
  )
}

export function PlayerDot({ color, size = 22 }) {
  return (
    <span
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        background: color,
        display: "inline-block",
        flexShrink: 0,
        border: `2px solid ${C.white}`,
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      }}
    />
  )
}
